import { DEMO_SCENES } from "./demo-data"

export const GUIDED_SCENE_ID = "SRV-K3A-20260718-ALB-0142"

export function guidedExplorerHref() {
  return `/portal/explorer?scene=${GUIDED_SCENE_ID}&guided=true`
}

export function guidedScene() {
  return DEMO_SCENES.find((scene) => scene.id === GUIDED_SCENE_ID)
}
